<mat-dialog-content>
  @if(!nonRemovableItems){
  <p>
    Are you sure to remove this order from your cart?
    You will remove {{itemsLength}} items
  </p>
  }@else{
    Sorry you can't remove these items.
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if(!nonRemovableItems){
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial (click)="remove()">Remove</button>
  }
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
